export async function getallconnectedaccounts(props: any = {}, data = {}) {
    return await props.di.GET('connector/request/getConnectedAccount/', data);
}

export async function getstepdeatails(props: any = {}, data = {}) {
    return await props.di.POST('amazon/product/getStepsDetails/', data);
}

export async function savestepdetails(props: any = {}, data = {}) {
    return await props.di.GET('amazon/product/saveStepsDetails/', data);
}

export async function savesellername(props: any = {}, data = {}) {
    return await props.di.GET('connector/request/saveSellerName/', data);
}

export async function setsellerstatus(props: any = {}, data = {}) {
    return await props.di.POST('connector/config/saveSellerStatus/', data);
}

export async function savesettingspreferences(props: any = {}, data = {}) {
    return await props.di.POST('connector/config/saveSettingPrefrences/', data);
}

export async function savechecklist(props: any = {}, data = {}) { //CALL on step 1
    return await props.di.POST('amazon/request/saveChecklist', data);
}

export async function isSellerAlreadySelling(props: any = {}, data = {}) { //CALL on step 1
    return await props.di.POST('amazon/request/isSellerAlreadySelling', data);
}